// extracted by mini-css-extract-plugin
module.exports = {"primary":"#4d727e","fontFamily":"\"Poppins\",sans-serif"};